import { render, staticRenderFns } from "./NsDynamicFieldset.vue?vue&type=template&id=2cfe8450&scoped=true&"
import script from "./NsDynamicFieldset.vue?vue&type=script&lang=js&"
export * from "./NsDynamicFieldset.vue?vue&type=script&lang=js&"
import style0 from "./NsDynamicFieldset.vue?vue&type=style&index=0&id=2cfe8450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe8450",
  null
  
)

export default component.exports